import { registerProtectedRoute } from '../../frontend/authStates'
import { registerRoute } from '../../frontend/router/routeRegistry'
import Home from './defaultTheme/pages/Home'
import Login from './defaultTheme/pages/Login'
import './defaultTheme/index.css'

export function registerRoutes() {
  registerRoute({
    path: '/login',
    viewFactory: () => <Login />
  })
  registerProtectedRoute({
    path: '/',
    viewFactory: () => <Home/>
  })
}